import { InstallationcostService } from '../services/installationcost.service';
import { RecommendationService } from '../services/recommendation.service';
import { Component, OnInit } from '@angular/core';
import { isHK } from 'app/app.component';

@Component({
  selector: 'app-savings',
  templateUrl: './savings.component.html',
  styleUrls: ['./savings.component.css']
})
export class SavingsComponent implements OnInit {

  constructor(private recommendationService: RecommendationService,
    private installationcostService: InstallationcostService) { }


  ngOnInit() {
  }

  getIsHK(): boolean {
    return isHK;
  }

  getSavings20() {
    let sv = this.recommendationService.get20ySavings();
    sv = Math.ceil(sv / 10) * 10;
    return sv;
  }

  getSavings20Netto() {
    return this.recommendationService.getSavings20Netto();
  }

  showSavings(): boolean {
    return this.getSavings20() > 0;
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/savings/savings.component.ts